import CampaignIcon from "@mui/icons-material/Whatshot";

import CampaignCreate from "./CampaignCreate";
import CampaignList from "./CampaignList";
import CampaignEdit from "./CampaignEdit";
import CampaignShow from "./CampaignShow";

const CampaignResourceProps = {
	name: "campaign",
	list: CampaignList,
	create: CampaignCreate,
	edit: CampaignEdit,
	show: CampaignShow,
};

export const CampaignMenuProps = {
	to: "/campaign",
	primaryText: "Campagnes",
	icon: CampaignIcon,
};

export default CampaignResourceProps;
